/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateAddressDto } from './create-address-dto';
/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    role?: CreateUserDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUserDto
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    customerType?: CreateUserDtoCustomerTypeEnum;
    /**
     * 
     * @type {Array<CreateAddressDto>}
     * @memberof CreateUserDto
     */
    addresses: Array<CreateAddressDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateUserDtoRoleEnum {
    SuperAdmin = 'SuperAdmin',
    Admin = 'Admin',
    User = 'User'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateUserDtoCustomerTypeEnum {
    B2B = 'B2B',
    Regular = 'Regular'
}

